// extracted by mini-css-extract-plugin
export var addButton = "_63-d";
export var bullets = "_63-e";
export var compact = "_63-2";
export var container = "_63-j";
export var extendedWarrantyModal = "_63-f";
export var learn = "_63-l";
export var learnMore = "_63-g";
export var offeringOption = "_63-3";
export var offeringPrice = "_63-8";
export var offeringSubtitle = "_63-7";
export var offeringTitle = "_63-6";
export var offeringsContainer = "_63-0";
export var pdpTilesBackground = "_63-n";
export var plan = "_63-m";
export var regular = "_63-1";
export var remove = "_63-k";
export var seeDetailsIcon = "_63-i";
export var seeDetailsLink = "_63-h";
export var selectedOption = "_63-4";
export var shieldIcon = "_63-b";
export var shieldIconCompact = "_63-c";
export var subtitle = "_63-a";
export var title = "_63-9";
export var unselectedOption = "_63-5";